import React from 'react';
import { ReactComponent as Enabled } from './enabled.svg';
import { ReactComponent as ForwardThick } from './ic-forward-thick.svg';
import { ReactComponent as Forward } from './ic-forward.svg';
import { ReactComponent as Transformation } from './sidebar/transformations_off.svg';
import { ReactComponent as Help } from './sidebar_help.svg';
import { ReactComponent as Rudder } from './ic-menu-rudder.svg';
import { ReactComponent as Signout } from './ic-signout.svg';
import { ReactComponent as Plus } from './plus.svg';
import { ReactComponent as Delete } from './delete.svg';
import { ReactComponent as Selected } from './selected.svg';
import { ReactComponent as Settings } from './settings.svg';
import { ReactComponent as SideArrow } from './sideArrow.svg';
import { ReactComponent as EmptyDestinations } from './emptyDestinations.svg';
import { ReactComponent as NoData } from './no-data.svg';
import { ReactComponent as NoDataGraph } from './no-data-graph.svg';
import { ReactComponent as LogoRudder } from './logo-rudder.svg';
import { ReactComponent as CaretDown } from './caret-down.svg';
import { ReactComponent as Calendar } from './calendar.svg';
import { ReactComponent as ChevronDown } from './chevron-down.svg';
import { ReactComponent as Bell } from './bell.svg';
import { ReactComponent as Close } from './close.svg';
import { ReactComponent as Check } from './check.svg';
import { ReactComponent as CheckWS } from './check_workspace_menu.svg';
import { ReactComponent as FilledCheckWS } from './check_workspace_menu_filled.svg';
import { ReactComponent as Workspace } from './workspace.svg';
import { ReactComponent as WorkspaceFilled } from './workspace_filled.svg';
import { ReactComponent as Edit } from './edit.svg';
import { ReactComponent as DotsHor } from './dots-hor.svg';
import { ReactComponent as DestTransformationActive } from './dest-transformation-active.svg';
import { ReactComponent as DestTransformationInactive } from './dest-transformation-inactive.svg';
import { ReactComponent as Pause } from './pause.svg';
import { ReactComponent as Clear } from './clear.svg';
import { ReactComponent as Tick } from './tick.svg';
import { ReactComponent as Warning } from './warning.svg';
import { ReactComponent as GithubLogo } from './github-logo.svg';
import { ReactComponent as GitLogo } from './git-logo.svg';
import { ReactComponent as GoogleLogo } from './google-logo.svg';
import { ReactComponent as RightArrow } from './rightArrow.svg';
import { ReactComponent as DirectorySourceCategory } from './directory_source_category.svg';
import { ReactComponent as AddMfa } from './add_mfa.svg';
import { ReactComponent as EmptyBox } from './empty_box.svg';
import { ReactComponent as EmptyList } from './emptyTrackingPlansList.svg';
import { ReactComponent as SyncFailed } from './sync_failed.svg';
import { ReactComponent as SyncAborted } from './sync_aborted.svg';
import { ReactComponent as SyncExecuting } from './sync_executing.svg';
import { ReactComponent as SyncWaiting } from './sync_waiting.svg';
import { ReactComponent as Search } from './magnifier.svg';
import { ReactComponent as ShortLeft } from './short_left.svg';
import { ReactComponent as ThinLongRight } from './thin_long_right.svg';
import { ReactComponent as EmptyPage } from './empty.svg';
import { ReactComponent as rudderstackLogo } from './rudderstack-logo.svg';
import { ReactComponent as arrowUnfoldMore } from './arrow_unfold_more.svg';
import { ReactComponent as Upgrade } from './upgrade.svg';
import { ReactComponent as ChevronRight } from './chevron_right.svg';
import { ReactComponent as Party } from './party.svg';
import { ReactComponent as Blendo } from './blendo.svg';
import { ReactComponent as CircleCheck } from './circle_check.svg';
import { ReactComponent as WarningAmber } from './warning_amber.svg';
import { ReactComponent as OffClose } from './off_close.svg';
import { ReactComponent as TransformationDebugger } from './ic-debug-transformations.svg';
import { ReactComponent as Phone } from './phone.svg';
import { ReactComponent as PlusBlack } from './plus-black.svg';
import { ReactComponent as Info } from './info.svg';
import { ReactComponent as MFASuccess } from './mfa_success.svg';
import { ReactComponent as PlayButton } from './play_button.svg';
import { ReactComponent as ExternalLink } from './external_link.svg';
import { ReactComponent as FullLogo } from './fullLogo.svg';
import { ReactComponent as FullLogoContrast } from './full_logo_contrast.svg';
import { ReactComponent as MatchNotFound } from './match_not_found.svg';
import { ReactComponent as ActionSuccess } from './action_success.svg';
import { ReactComponent as DirectoryRequest } from './directory_request.svg';
import { ReactComponent as Rectangle } from './rectangle.svg';
import { ReactComponent as WarehouseComponent } from './warehouse_onboard.svg';
import { ReactComponent as SourceComponent } from './source_onboard.svg';
import { ReactComponent as DestinationComponent } from './destination_onboard.svg';
import { ReactComponent as ActivationAllDisabled } from './activation_all_disabled.svg';
import { ReactComponent as ActivationWarehouseEnabled } from './activation_warehouse_enabled.svg';
import { ReactComponent as ActivationSourceEnabled } from './activation_source_enabled.svg';
import { ReactComponent as ActivationCloudEnabled } from './activation_cloud_enabled.svg';
import { ReactComponent as ActivationSourceCloudEnabled } from './activation_source_cloud_enabled.svg';
import { ReactComponent as ActivationWarehouseSourceEnabled } from './activation_warehouse_source_enabled.svg';
import { ReactComponent as ActivationWarehouseCloudEnabled } from './activation_warehouse_cloud_enabled.svg';
import { ReactComponent as ActivationAllEnabled } from './activation_all_enabled.svg';
import { ReactComponent as LinkResource } from './link_resource.svg';
import { ReactComponent as Dashboard } from './dashboard.svg';
import { ReactComponent as Mail } from './mail.svg';
import { ReactComponent as Book } from './book.svg';
import { ReactComponent as Documentation } from './help_documentation.svg';
import { ReactComponent as HelpSlackComponent } from './help_slack.svg';
import { ReactComponent as HelpVideo } from './help_video.svg';
import { ReactComponent as LogoV3 } from './logo_v3.svg';
import { ReactComponent as SidebarRevampGetStarted } from './sidebarRevamp/get_started.svg';
import { ReactComponent as SidebarRevampGetStartedActive } from './sidebarRevamp/get_started_active.svg';
import { ReactComponent as SidebarRevampDirectory } from './sidebarRevamp/directory.svg';
import { ReactComponent as SidebarRevampDirectoryActive } from './sidebarRevamp/directory_active.svg';
import { ReactComponent as SidebarRevampConnection } from './sidebarRevamp/connections.svg';
import { ReactComponent as SidebarRevampConnectionActive } from './sidebarRevamp/connections_active.svg';
import { ReactComponent as SidebarRevampTransformation } from './sidebarRevamp/transformation.svg';
import { ReactComponent as SidebarRevampTransformationActive } from './sidebarRevamp/transformation_active.svg';
import { ReactComponent as SidebarRevampMonitor } from './sidebarRevamp/monitor.svg';
import { ReactComponent as SidebarRevampMonitorActive } from './sidebarRevamp/monitor_active.svg';
import { ReactComponent as SidebarRevampSetting } from './sidebarRevamp/setting.svg';
import { ReactComponent as SidebarRevampSettingActive } from './sidebarRevamp/setting_active.svg';
import { ReactComponent as SidebarRightIcon } from './sidebarRevamp/chevron_right.svg';
import { ReactComponent as MobileLogo } from './sidebarRevamp/logo_mobile.svg';
import { ReactComponent as SidebarCollapse } from './sidebarRevamp/sidebar_collapse.svg';
import { ReactComponent as SidebarExpand } from './sidebarRevamp/sidebar_expand.svg';
import { ReactComponent as NoResultsFound } from './no_results_found.svg';
import { ReactComponent as UserFilled } from './user_filled.svg';

interface SvgProps extends React.SVGAttributes<unknown> {
  name: string;
  size?: number;
  fill?: string;
}

const Svg = ({ name = '', size, ...svgProps }: SvgProps) => {
  let Icon;
  switch (name && name.toLowerCase()) {
    case 'rudder':
      Icon = Rudder;
      break;
    case 'sidebar-revamp-get-started':
      Icon = SidebarRevampGetStarted;
      break;
    case 'sidebar-revamp-get-started-active':
      Icon = SidebarRevampGetStartedActive;
      break;
    case 'sidebar-revamp-directory':
      Icon = SidebarRevampDirectory;
      break;
    case 'sidebar-revamp-directory-active':
      Icon = SidebarRevampDirectoryActive;
      break;
    case 'sidebar-revamp-connection':
      Icon = SidebarRevampConnection;
      break;
    case 'sidebar-revamp-connection-active':
      Icon = SidebarRevampConnectionActive;
      break;
    case 'sidebar-transformation':
      Icon = SidebarRevampTransformation;
      break;
    case 'sidebar-transformation-active':
      Icon = SidebarRevampTransformationActive;
      break;
    case 'sidebar-revamp-monitor':
      Icon = SidebarRevampMonitor;
      break;
    case 'sidebar-revamp-monitor-active':
      Icon = SidebarRevampMonitorActive;
      break;
    case 'sidebar-revamp-setting':
      Icon = SidebarRevampSetting;
      break;
    case 'sidebar-revamp-setting-active':
      Icon = SidebarRevampSettingActive;
      break;
    case 'logo-mobile':
      Icon = MobileLogo;
      break;
    case 'sidebar-collapse':
      Icon = SidebarCollapse;
      break;
    case 'sidebar-expand':
      Icon = SidebarExpand;
      break;
    case 'sidebar-right-icon':
      Icon = SidebarRightIcon;
      break;
    case 'user-filled':
      Icon = UserFilled;
      break;
    case 'ed':
      Icon = EmptyDestinations;
      break;
    case 'transformation':
      Icon = Transformation;
      break;
    case 'selected':
      Icon = Selected;
      break;
    case 'signout':
      Icon = Signout;
      break;
    case 'forward':
      Icon = Forward;
      break;
    case 'play-button':
      Icon = PlayButton;
      break;
    case 'forward-thick':
      Icon = ForwardThick;
      break;
    case 'settings':
      Icon = Settings;
      break;
    case 'side-arrow':
      Icon = SideArrow;
      break;
    case 'right-arrow':
      Icon = RightArrow;
      break;
    case 'plus':
      Icon = Plus;
      break;
    case 'plus-black':
      Icon = PlusBlack;
      break;
    case 'enabled':
      Icon = Enabled;
      break;
    case 'no-data':
      Icon = NoData;
      break;
    case 'no-data-graph':
      Icon = NoDataGraph;
      break;
    case 'logo-rudder':
      Icon = LogoRudder;
      break;
    case 'delete':
      Icon = Delete;
      break;
    case 'chevron-down':
      Icon = ChevronDown;
      break;
    case 'bell':
      Icon = Bell;
      break;
    case 'close':
      Icon = Close;
      break;
    case 'check':
      Icon = Check;
      break;
    case 'check_ws_menu':
      Icon = CheckWS;
      break;
    case 'filled-check_ws_menu':
      Icon = FilledCheckWS;
      break;
    case 'workspace':
      Icon = Workspace;
      break;
    case 'workspace-filled':
      Icon = WorkspaceFilled;
      break;
    case 'caret-down':
      Icon = CaretDown;
      break;
    case 'edit':
      Icon = Edit;
      break;
    case 'dots-hor':
      Icon = DotsHor;
      break;
    case 'dest-transformation-active':
      Icon = DestTransformationActive;
      break;
    case 'dest-transformation-inactive':
      Icon = DestTransformationInactive;
      break;
    case 'info':
      Icon = Info;
      break;
    case 'warning':
      Icon = Warning;
      break;
    case 'pause':
      Icon = Pause;
      break;
    case 'clear':
      Icon = Clear;
      break;
    case 'tick':
      Icon = Tick;
      break;
    case 'github':
      Icon = GithubLogo;
      break;
    case 'git-logo':
      Icon = GitLogo;
      break;
    case 'google':
      Icon = GoogleLogo;
      break;
    case 'full-logo_02':
      Icon = FullLogo;
      break;
    case 'full-logo_02_contrast':
      Icon = FullLogoContrast;
      break;
    case 'calendar':
      Icon = Calendar;
      break;
    case 'directory_source_category':
      Icon = DirectorySourceCategory;
      break;
    case 'sync-failed':
      Icon = SyncFailed;
      break;
    case 'sync-aborted':
      Icon = SyncAborted;
      break;
    case 'sync-executing':
      Icon = SyncExecuting;
      break;
    case 'sync-waiting':
      Icon = SyncWaiting;
      break;
    case 'search':
      Icon = Search;
      break;
    case 'short-left':
      Icon = ShortLeft;
      break;
    case 'thin-long-right':
      Icon = ThinLongRight;
      break;
    case 'empty-page':
      Icon = EmptyPage;
      break;
    case 'rudderstack-logo':
      Icon = rudderstackLogo;
      break;
    case 'arrow_unfold_more':
      Icon = arrowUnfoldMore;
      break;
    case 'upgrade':
      Icon = Upgrade;
      break;
    case 'help':
      Icon = Help;
      break;
    case 'arrow_chevron_right':
      Icon = ChevronRight;
      break;
    case 'blendo':
      Icon = Blendo;
      break;
    case 'party':
      Icon = Party;
      break;
    case 'circle_check':
      Icon = CircleCheck;
      break;
    case 'warning_amber':
      Icon = WarningAmber;
      break;
    case 'activation-all-disabled':
      Icon = ActivationAllDisabled;
      break;
    case 'activation-warehouse-enabled':
      Icon = ActivationWarehouseEnabled;
      break;
    case 'activation-source-enabled':
      Icon = ActivationSourceEnabled;
      break;
    case 'activation-cloud-enabled':
      Icon = ActivationCloudEnabled;
      break;
    case 'activation-source-cloud-enabled':
      Icon = ActivationSourceCloudEnabled;
      break;
    case 'activation-warehouse-source-enabled':
      Icon = ActivationWarehouseSourceEnabled;
      break;
    case 'activation-warehouse-cloud-enabled':
      Icon = ActivationWarehouseCloudEnabled;
      break;
    case 'activation-all-enabled':
      Icon = ActivationAllEnabled;
      break;
    case 'logo-v3':
      Icon = LogoV3;
      break;
    case 'link-resource':
      Icon = LinkResource;
      break;
    case 'rectangle':
      Icon = Rectangle;
      break;
    case 'warehouse-onboard':
      Icon = WarehouseComponent;
      break;
    case 'source-onboard':
      Icon = SourceComponent;
      break;
    case 'destination-onboard':
      Icon = DestinationComponent;
      break;
    case 'dashboard':
      Icon = Dashboard;
      break;
    case 'mail':
      Icon = Mail;
      break;
    case 'book':
      Icon = Book;
      break;
    case 'help-documentation':
      Icon = Documentation;
      break;
    case 'help-slack':
      Icon = HelpSlackComponent;
      break;
    case 'help-video':
      Icon = HelpVideo;
      break;
    case 'off_close':
      Icon = OffClose;
      break;
    case 'transformationDebugger':
      Icon = TransformationDebugger;
      break;
    case 'phone':
      Icon = Phone;
      break;
    case 'add_mfa':
      Icon = AddMfa;
      break;
    case 'mfa_success':
      Icon = MFASuccess;
      break;
    case 'external_link':
      Icon = ExternalLink;
      break;
    case 'match_not_found':
      Icon = MatchNotFound;
      break;
    case 'empty_box':
      Icon = EmptyBox;
      break;
    case 'action_success':
      Icon = ActionSuccess;
      break;
    case 'empty_list':
      Icon = EmptyList;
      break;
    case 'directory_request':
      Icon = DirectoryRequest;
      break;
    case 'no_results_found':
      Icon = NoResultsFound;
      break;
    default:
      break;
  }
  const sizeProps =
    (size && {
      width: size,
      height: size,
    }) ||
    {};
  return Icon ? <Icon {...sizeProps} {...svgProps} /> : <div />;
};

export default Svg;
